"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.expireKey = exports.cacheForSync = exports.cacheFor = void 0;
const time_1 = require("./time");
const cache = {};
/**
 * A crude caching system that will cache values for the given time.
 *
 * @param options See `CacheForOptions`.
 * @param generator The promise function that returns the cached value.
 */
exports.cacheFor = ({ key, duration }, generator) => __awaiter(void 0, void 0, void 0, function* () {
    if (!cache[key]) {
        const value = yield generator();
        return exports.cacheForSync({ key, duration }, () => value);
    }
    return cache[key];
});
/**
 * A crude caching system that will cache values for the given time.
 *
 * @param options See `CacheForOptions`.
 * @param generator The function that returns the cached value.
 */
exports.cacheForSync = ({ key, duration }, generator) => {
    if (!cache[key]) {
        cache[key] = generator();
        setTimeout(() => {
            delete cache[key];
        }, (duration ? duration : time_1.minutesInMs(5)));
    }
    return cache[key];
};
exports.expireKey = (key) => {
    delete cache[key];
};
//# sourceMappingURL=cache-for.js.map